import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { NgClass } from '@angular/common';
import { ExternalLinkDirective } from '../../directives/external-link/external-link.directive';
import { RouterLink } from '@angular/router';

export interface IChipConfig {
	icon: string; content: string; allowDismiss: boolean; action?: { label: string; url: string; id: string; }; type: 'info' | 'warning' | 'danger' | 'success' | 'neutral';
}

@Component({
    selector: 'bt-chips',
    templateUrl: './chips.component.html',
    styleUrls: ['./chips.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [NgClass, ExternalLinkDirective, RouterLink]
})

export class ChipsComponent {

	@Input() public config: IChipConfig | undefined;
	public active = true;
}
